/**
 * MetadataExtractionDialog.jsx
 *
 * Wraps ExtractionReviewPanel in a full-height dialog.
 * Accessible from the Synopsis Tools Hub for any open project.
 * Uses the active project from the store — no props required for projectId.
 */
import React from 'react';
import { Sparkles } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { usePW } from '@/lib/store';
import ExtractionReviewPanel from '@/components/panels/ExtractionReviewPanel';

export default function MetadataExtractionDialog({ open, onOpenChange }) {
  const { project } = usePW();
  const pid = project?.id;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="max-w-2xl gap-0 overflow-hidden p-0 h-[88vh] flex flex-col"
        data-testid="metadata-extraction-dialog"
      >
        <DialogHeader className="shrink-0 border-b border-border px-5 py-4">
          <DialogTitle className="flex items-center gap-2 text-base">
            <Sparkles className="h-4 w-4 text-primary" />
            AI Metadata Extraction
          </DialogTitle>
          <p className="mt-0.5 text-[12px] text-muted-foreground">
            The AI reads your manuscript and extracts synopsis, genre, characters, world bible, codex entries, plot beats and more.
            Review and adjust each field before applying to your project.
          </p>
        </DialogHeader>

        <div className="flex-1 overflow-y-auto px-5 py-4">
          {pid ? (
            <ExtractionReviewPanel
              projectId={pid}
              onApplied={() => {}}
            />
          ) : (
            <div className="flex items-center justify-center h-32 text-[12px] text-muted-foreground">
              Open a project first to run extraction.
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
